import { getBaseQuery, getBaseUrl } from '../api.util.ts'
import { createApi } from '@reduxjs/toolkit/query/react'
import { RankingListRequest, RankingListResponse } from './ranking-api.def.ts'

const interfaceName = 'ranking'

export const rankingApi = createApi({
  reducerPath: 'rankingApi',
  baseQuery: getBaseQuery(getBaseUrl(interfaceName)),
  tagTypes: ['ranking'],
  endpoints: (build) => ({
    listRanking: build.query<RankingListResponse, RankingListRequest>({
      query: (params) => ({
        url: '/',
        method: 'GET',
        params: params,
      }),
      providesTags: ['ranking'],
    }),
  }),
})

export const { useListRankingQuery } = rankingApi
